import React, { useState, useMemo, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { useDebouncedCallback } from "use-debounce";
import { Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";

import SearchField from "../searchField/SearchField";
import TableCustomHeader from "../table/TableCustomHeader";
import { shopifyActions, transactionActions } from "../../../redux/actions";
import ServerPaginationTable from "../agGrid/ServerPaginationTable";
import InfiniteScrollTable from "../agGrid/InfiniteScrollTable";
import { printReceiptData } from "../../Printers/ReceiptPrinters/printReceipt";
import CategoriesDropdown from "../../../shared/components/selectDropdown/CategoriesDropdown";
import { prepareReceiptForPrinter } from "../../Printers/ReceiptPrinters/prepareReceiptForPrinter";
import { prepareReceiptForPrinterTrade } from "../../Printers/ReceiptPrinters/prepareReceiptForPrinterTrade";
import {
  ACTIVITY_TYPES_ENUMS,
  PRODUCT_TYPES_ENUMS,
} from "../../../system/globalEnums";
import {
  toastType,
  EMPTY_STRING,
  skeletonArray,
  toastMessages,
  globalConstants,
  defaultGridState,
  inventoryConstants,
  buttonNameConstants,
  transactionConstants,
  categoryDropdownConstants,
  ITEM_HISTORY_DATEPICKER_OPTIONS,
  TABLE_IDS,
} from "../../../constants";
import {
  ShowIcon,
  CrossIcon,
  SearchIcon,
  BlueBoxIcon,
  PrintIcon,
} from "../../../assets/icons/iconsProvider";
import {
  getRowId,
  getRowStyle,
  customToast,
  getTimeFrame,
  isSpinnerEnabled,
  LoadingIndicator,
  isSaleTransaction,
  isTradeTransaction,
  getCustomerFullName,
  getReceiptPrintDate,
  getUnitPurchasePrice,
  parseToThousandSeperatorDecimalNumber,
  isButtonDisable,
  handleMarkOrderAsOpen,
  handleMarkOrderAsReady,
  handleMarkOrderAsFulfilled,
  getUserNameOnReceipt,
  isShopifyOrderHistory,
  handlePrintShopifyPackingSlips,
  handleTransferToLocation,
  getActionColumnOfAgGridReact,
  getOutletColumn,
  getTotalQuantityOfTransaction,
  getVoidButtonTooltip,
  isVoidDisabled,
  isEmployeeLogin,
  getTotalAmountFromTransaction,
} from "../../utility";
import { success } from "../../../redux/actions/actionsUtilities";
import CustomCellRendererWithSkeleton from "../agGrid/CustomCellRendererWithSkeleton";
import DashboardDatePicker from "../datetimePickerDropdown/DashboardDatePicker";
import { shopifyService } from "../../../services";
import OrderDetailsModal from "../../../views/SellAndTrade/Orders/OrderDetailsModal/OrderDetailsModal";
import TransactionHistoryOrderDetailsModal from "../transactionHistory/TransactionHistoryOrderDetailsModal";
import { useCompanyStoreFilter } from "../../hooks/useCompanyStoreFilter";
import CompanyStoreDropdown from "../selectDropdown/CompanyStoreDropdown";
import VoidTransactionModal from "./VoidTransactionModal";
import { Ban } from "react-bootstrap-icons";

const TransactionHistoryTableWithFilters = (props) => {
  const {
    user,
    option,
    setOption,
    searchText,
    currentStore,
    spinnerArray,
    allCustomers,
    setSearchText,
    paginationData,
    sendEmailOrSMS,
    sellTradeHistory,
    getAllTransaction,
    emptyAllTransaction,
    defaultReceiptPrinter,
    isInfiniteScroll = false,
    updateCustomerInTransactionHistory,
    tableHeight = `calc(100vh - 320px)`,
    isCustomerLogsModal = {
      isSearchField: true,
      customer: { id: EMPTY_STRING },
    },
    datePickerOptions = ITEM_HISTORY_DATEPICKER_OPTIONS,
    updateShopifyOrderStatus,
    currentStoreCompany,
    stores,
    tableId = TABLE_IDS.TRANSACTION_HISTORY,
    updateVoidTransactionHistory,
  } = props;
  const gridRef = useRef();
  const [show, setShow] = useState(false);
  const [viewCartDetail, setViewCartDetail] = useState([]);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [isShowOrderDetail, setIsShowOrderDetail] = useState(false);
  const [debouncedSearchText, setDebouncedSearchText] = useState(EMPTY_STRING);
  const [gridState, setGridState] = useState(
    isCustomerLogsModal.customer.id
      ? { ...defaultGridState, searchQuery: isCustomerLogsModal.customer.id }
      : defaultGridState
  );
  const [showVoidModal, setShowVoidModal] = useState(false);
  const [transactionToVoid, setTransactionToVoid] = useState(null);
  const [showVoidDetails, setShowVoidDetails] = useState(false);

  const handleInitiateVoid = (data, showDetails = false) => {
    if (
      data?.store?.id &&
      currentStore?.id &&
      data.store.id !== currentStore.id
    ) {
      customToast(toastMessages.CANNOT_VOID_DIFFERENT_STORE, toastType.ERROR);
      return;
    }
    setTransactionToVoid(data);
    setShowVoidDetails(showDetails);
    setShowVoidModal(true);
  };
  const hasAccessToVoidTransaction =
    !isEmployeeLogin(user) &&
    !isInfiniteScroll; /* Don't show void button for employee login and infinite scroll table 
    (as infinite scroll table is used in customer logs modal and void button is not required there) */
  const [timeFrame, setTimeFrame] = useState({
    start: EMPTY_STRING,
    end: EMPTY_STRING,
    duration: "daily",
  });

  const { selectedStore, setSelectedStore, companyStores, selectedStoreId } =
    useCompanyStoreFilter(currentStoreCompany, currentStore, stores, true);
  const toggleOrderDetailModal = () => {
    setIsShowOrderDetail((prev) => {
      prev && updateGridState(gridState);
      return !prev;
    });
  };
  const handleVoidTransaction = (dataToSend) => {
    let txType = transactionToVoid?.type;
    let endpoint = "transaction";
    if (txType === ACTIVITY_TYPES_ENUMS.TRADE) {
      endpoint = "trade";
    } else {
      txType = ACTIVITY_TYPES_ENUMS.TRANSACTION;
      endpoint = "transaction";
    }

    const transactionDetails = {
      storeId: transactionToVoid?.store?.id,
      id: transactionToVoid?.id,
      type: option?.value || "All",
      start: timeFrame.start,
      end: timeFrame.end,
      companyId: currentStoreCompany?.id,
    };

    updateVoidTransactionHistory(
      dataToSend,
      transactionDetails,
      gridState,
      endpoint
    );

    setTransactionToVoid(null);
  };

  const actionCellRenderer = (params) => (
    <CustomCellRendererWithSkeleton
      params={params}
      cellComponent={
        <div className="d-flex justify-content-center align-items-center">
          <button
            type="button"
            onClick={async () => {
              if (isShopifyOrderHistory(params.data)) {
                const shopifyOrder = await shopifyService.getShopifyOrderById(
                  currentStore?.id,
                  params.data?.shopifyOrderId
                );
                handlePrintShopifyPackingSlips([shopifyOrder], currentStore);
              } else {
                handlePrintReceipt(params.data);
              }
            }}
            className={`action-Button-Wrapper`}
          >
            <PrintIcon className="cursor-pointer text-primary history-view-icon" />
          </button>
          <button
            className="action-Button-Wrapper"
            onClick={() => {
              handleViewCart(params.data);
            }}
          >
            <ShowIcon className="cursor-pointer text-primary history-view-icon" />
          </button>
          {hasAccessToVoidTransaction && (
            <OverlayTrigger
              placement="top"
              overlay={
                getVoidButtonTooltip(params.data) ? (
                  <Tooltip id={`tooltip-void-${params.data.id}`}>
                    {getVoidButtonTooltip(params.data)}
                  </Tooltip>
                ) : (
                  <></>
                )
              }
            >
              <span className="d-inline-block">
                <button
                  className="action-Button-Wrapper"
                  disabled={isVoidDisabled(params.data)}
                  style={{
                    pointerEvents: isVoidDisabled(params.data)
                      ? "none"
                      : "auto",
                    opacity: isVoidDisabled(params.data) ? 0.5 : 1,
                  }}
                  onClick={() => {
                    handleInitiateVoid(params.data, true);
                  }}
                >
                  <Ban
                    color="red"
                    className="cursor-pointer text-primary history-view-icon"
                  />
                </button>
              </span>
            </OverlayTrigger>
          )}
        </div>
      }
      componentRenderCondition={params.data?.id}
    />
  );
  const HistoryColumnsPaginationTable = useMemo(
    () => [
      {
        headerName: "Sale ID",
        field: "id",
        cellRenderer: (params) => (
          <CustomCellRendererWithSkeleton
            params={params}
            cellComponent={`${params.data.id}`}
          />
        ),
      },
      {
        headerName: "Date",
        headerTooltip: "Date",
        field: "createdOn",
        cellRenderer: (params) => (
          <CustomCellRendererWithSkeleton
            params={params}
            titleToolTipText={getReceiptPrintDate(params.data.createdOn)}
            cellComponent={
              <span className="inventory-cell-max-size">
                {getReceiptPrintDate(params.data.createdOn)}
              </span>
            }
            componentRenderCondition={params?.data?.createdOn}
          />
        ),
      },
      {
        headerName: "Transaction Type",
        headerTooltip: "Transaction Type",
        field: "type",
        cellRenderer: (params) => (
          <CustomCellRendererWithSkeleton
            params={params}
            cellComponent={`${params.data.type}`}
            componentRenderCondition={params?.data?.type}
          />
        ),
      },
      {
        headerName: "Payment",
        headerTooltip: "Payment",
        field: "PaymentType",
        cellRenderer: (params) => (
          <CustomCellRendererWithSkeleton
            params={params}
            cellComponent={
              <span className="inventory-cell-max-size ">
                {params?.data?.PaymentType === transactionConstants.CREDIT_CARD
                  ? buttonNameConstants.CREDIT_CARD
                  : params?.data?.PaymentType === transactionConstants.GIFT_CARD
                  ? buttonNameConstants.GIFT_CARD_PAYMENT
                  : params?.data?.PaymentType ===
                    transactionConstants.STORE_CREDIT
                  ? buttonNameConstants.STORE_CREDIT
                  : params?.data?.PaymentType === transactionConstants.OTHER
                  ? buttonNameConstants.OTHER
                  : params?.data?.PaymentType === transactionConstants.SPLIT
                  ? buttonNameConstants.SPLIT
                  : buttonNameConstants.CASH}
              </span>
            }
            componentRenderCondition={params?.data?.PaymentType !== undefined}
          />
        ),
      },
      {
        headerName: "Cart QTY",
        field: "cartQuantity",
        cellRenderer: (params) => (
          <CustomCellRendererWithSkeleton
            params={params}
            cellComponent={
              params?.data?.cartQuantity ||
              getTotalQuantityOfTransaction(params?.data)
            }
            componentRenderCondition={params?.data?.inventory}
          />
        ),
      },
      {
        headerName: "Customer",
        field: "customer.name",
        cellRenderer: (params) => (
          <CustomCellRendererWithSkeleton
            params={params}
            cellComponent={
              <span className="inventory-cell-max-size">
                {getCustomerFullName(params?.data?.customer, true)}
              </span>
            }
            componentRenderCondition={params?.data?.customer}
          />
        ),
      },
      {
        headerName: "Total COGS",
        field: "initialTotalCogs",
        valueGetter: (params) => params?.data?.initialTotalCogs,
        cellRenderer: (params) => (
          <CustomCellRendererWithSkeleton
            params={params}
            cellComponent={`$${parseToThousandSeperatorDecimalNumber(
              params?.data?.initialTotalCogs || 0
            )}`}
            componentRenderCondition={
              params?.data?.totalAmountToPay &&
              params.data?.totalAmountToPay !== 0
            }
          />
        ),
      },
      {
        headerName: "Total Amount",
        field: "totalAmount",
        valueGetter: (params) => getTotalAmountFromTransaction(params.data),
        cellRenderer: (params) => (
          <CustomCellRendererWithSkeleton
            params={params}
            cellComponent={`$${parseToThousandSeperatorDecimalNumber(
              getTotalAmountFromTransaction(params?.data)
            )}`}
            componentRenderCondition={
              params?.data?.totalAmountToPay ||
              params?.data?.totalAmountToPay === 0
            }
          />
        ),
      },
      getOutletColumn({ currentStore }),
      {
        headerName: "Store",
        field: "store.name",
        cellRenderer: (params) => (
          <CustomCellRendererWithSkeleton
            params={params}
            cellComponent={params?.data?.store?.name}
          />
        ),
      },
      getActionColumnOfAgGridReact(actionCellRenderer),
    ],
    // eslint-disable-next-line
    [currentStore]
  );
  const HistoryColumnsInfiniteScrollTable = useMemo(
    () => [
      {
        id: "saleId",
        header: "Sale ID",
        accessorKey: "saleId",
        cell: (props) => (
          <CustomCellRendererWithSkeleton
            params={props}
            cellComponent={`${props?.row?.original?.id}`}
            componentRenderCondition={props?.row?.original?.id}
          />
        ),
        enableSorting: false,
      },
      {
        id: "createdOn",
        header: "Date",
        accessorKey: "createdOn",
        cell: (props) => (
          <CustomCellRendererWithSkeleton
            params={props}
            cellComponent={
              <span className="inventory-cell-max-size ">
                <TableCustomHeader
                  id={`created-on-in-array-${props?.row?.original?.id}`}
                  label={
                    <span className="inventory-cell-max-size">
                      {getReceiptPrintDate(props?.row?.original?.createdOn)}
                    </span>
                  }
                  toolTipText={
                    <p className="text-start fw-normal m-0">
                      {getReceiptPrintDate(props?.row?.original?.createdOn)}
                    </p>
                  }
                  className="sku-tooltip"
                />
              </span>
            }
            componentRenderCondition={props?.row?.original?.createdOn}
          />
        ),
        enableSorting: false,
      },
      {
        id: "TransactionType",
        header: "Transaction Type",
        accessorKey: "TransactionType",
        cell: (props) => (
          <CustomCellRendererWithSkeleton
            params={props}
            cellComponent={`${props?.row?.original?.type}`}
            componentRenderCondition={props?.row?.original?.type}
          />
        ),
        enableSorting: false,
      },
      {
        id: "paymentType",
        header: "Payment",
        accessorKey: "paymentType",
        cell: (props) => (
          <CustomCellRendererWithSkeleton
            params={props}
            cellComponent={
              <span className="inventory-cell-max-size ">
                {props?.row?.original?.PaymentType ===
                transactionConstants.CREDIT_CARD
                  ? buttonNameConstants.CREDIT_CARD
                  : props?.row?.original?.PaymentType ===
                    transactionConstants.GIFT_CARD
                  ? buttonNameConstants.GIFT_CARD_PAYMENT
                  : props?.row?.original?.PaymentType ===
                    transactionConstants.STORE_CREDIT
                  ? buttonNameConstants.STORE_CREDIT
                  : props?.row?.original?.PaymentType ===
                    transactionConstants.OTHER
                  ? buttonNameConstants.OTHER
                  : buttonNameConstants.CASH}
              </span>
            }
            componentRenderCondition={props?.row?.original?.PaymentType}
          />
        ),
        enableSorting: false,
      },
      {
        id: "cartQuantity",
        header: "Cart QTY",
        accessorKey: "cartQuantity",
        cell: (props) => (
          <CustomCellRendererWithSkeleton
            params={props}
            cellComponent={
              props?.row?.original?.inventory?.reduce(
                (a, b) => a + Number(b.quantity),
                0
              ) ||
              props?.row?.original?.inventory?.reduce(
                (a, b) => a + Number(b.price.quantity),
                0
              ) ||
              0
            }
            componentRenderCondition={props?.row?.original?.inventory}
          />
        ),
        enableSorting: false,
      },
      {
        id: "customer",
        header: "Customer",
        accessorKey: "customer",
        cell: (props) => (
          <CustomCellRendererWithSkeleton
            params={props}
            cellComponent={
              <span className="inventory-cell-max-size">
                {getCustomerFullName(props?.row?.original?.customer)}
              </span>
            }
            componentRenderCondition={props?.row?.original?.customer}
          />
        ),
        enableSorting: false,
      },
      {
        id: "amount",
        header: "Amount",
        accessorKey: "amount",
        cell: (props) => (
          <CustomCellRendererWithSkeleton
            params={props}
            cellComponent={`$${parseToThousandSeperatorDecimalNumber(
              props?.row?.original?.totalAmountToPay
            )}`}
            componentRenderCondition={
              props?.row?.original?.totalAmountToPay ||
              props?.row?.original?.totalAmountToPay === 0
            }
          />
        ),
        enableSorting: false,
      },
      {
        id: "currentBalance",
        header: "Store Credit",
        accessorKey: "currentBalance",
        cell: (props) => (
          <CustomCellRendererWithSkeleton
            params={props}
            cellComponent={`
              $${parseToThousandSeperatorDecimalNumber(
                props?.row?.original?.customer?.currentBalance
              )}`}
            componentRenderCondition={props?.row?.original?.customer?.id}
          />
        ),
        enableSorting: false,
      },
      {
        id: "id",
        header: EMPTY_STRING,
        accessorKey: "id",
        cell: (props) => (
          <CustomCellRendererWithSkeleton
            params={props}
            componentRenderCondition={props?.row?.original?.id}
            cellComponent={
              <div className="d-flex justify-content-end gap-2">
                <button
                  className="action-Button-Wrapper ps-0 pe-0"
                  onClick={() => {
                    handleViewCart(props?.row?.original);
                  }}
                >
                  <ShowIcon className="cursor-pointer text-primary history-view-icon" />
                </button>
              </div>
            }
          />
        ),
        enableSorting: false,
      },
    ],
    // eslint-disable-next-line
    []
  );

  // helper functions
  const gridData = useMemo(() => {
    let filteredData = sellTradeHistory || [];
    setGridState({
      ...gridState,
      pageIndex: paginationData?.pageNumber || defaultGridState?.pageIndex,
      totalRecords:
        paginationData?.totalRecords || defaultGridState?.totalRecords,
      pageEndRecordNumber:
        paginationData?.pageEndRecordNumber ||
        defaultGridState?.pageEndRecordNumber,
      pageStartRecordNumber:
        paginationData?.pageStartRecordNumber ||
        defaultGridState?.pageStartRecordNumber,
    });
    setIsSearchLoading(false);
    return filteredData;
    // eslint-disable-next-line
  }, [sellTradeHistory]);
  const toggleCustomTradeModal = () => {
    setShow(!show);
  };

  const handleHideModal = () => {
    setShow(!show);
    setViewCartDetail([]);
  };

  const clearSearchText = () => {
    setSearchText("");
    setDebouncedSearchText("");
    updateGridState({ ...gridState, searchQuery: EMPTY_STRING });
  };
  const handleDebouncedSearch = useDebouncedCallback((value) => {
    updateGridState({ ...gridState, searchQuery: value, pageIndex: 1 });
  }, 1000);
  const handleSearchInputChange = (value) => {
    setIsSearchLoading(true);
    handleDebouncedSearch(value);
    setDebouncedSearchText(value);
  };
  const updateGridState = (gridState) => {
    if (!selectedStoreId) {
      return;
    }
    getAllTransaction(
      selectedStoreId,
      option?.value,
      timeFrame.start,
      timeFrame.end,
      gridState,
      EMPTY_STRING
    );
    setGridState(gridState);
  };
  const handleGetTimeFrame = (value) => {
    getTimeFrame(value, timeFrame, setTimeFrame);
  };
  const handleUpdateCustomer = (customer) => {
    const transactionType = isTradeTransaction(viewCartDetail?.[0])
      ? "trade"
      : isSaleTransaction(viewCartDetail?.[0])
      ? "transaction"
      : "return";

    const customerData = customer?.id
      ? customer
      : { name: EMPTY_STRING, id: EMPTY_STRING };
    const { id } = viewCartDetail?.[0] || {};

    if (!selectedStoreId) {
      return;
    }

    const transactionDetails = {
      id,
      selectedStoreId,
      storeId: viewCartDetail?.[0]?.store?.id,
      type: option?.value,
      start: timeFrame.start,
      end: timeFrame.end,
    };

    updateCustomerInTransactionHistory(
      { customer: customerData },
      transactionDetails,
      gridState,
      transactionType
    );
  };
  const handlePrintReceipt = (newTradeData, isGiftReceipt = false) => {
    if (newTradeData.id.substring(0, 3) === globalConstants.TYPE_ID_TRD) {
      handlePrintReceiptTrade(newTradeData, isGiftReceipt);
    } else {
      const printData = prepareReceiptForPrinter(
        newTradeData,
        getUserNameOnReceipt(newTradeData, user),
        newTradeData.id,
        newTradeData.paymentHistory,
        currentStore,
        allCustomers?.find((customer) => {
          if (customer.id === newTradeData?.customer?.id) {
            return {
              ...newTradeData?.customer,
              currentBalance: customer.currentBalance,
            };
          }
          return false;
        }) || {},
        [
          ...newTradeData?.inventory?.map((inv) => {
            return {
              ...inv,
              cogs: inv?.price?.unit_purchase_price,
              item: inv?.product_name,
              priceAfterDiscount: inv?.price?.unit_purchase_price,
              itemName: inv?.product_name,
              quantity: inv?.price?.quantity,
              productType: inv?.productType,
              category: inv?.category_name,
              // max: 2,
              // actualPrice: inv?.price?.unit_sell_price,
              // isDiscountApplied: false,
              // discountPercentage: 0,
              // priceAfterDiscount: 1000,
              // actualDiscountPercentage: 0,
            };
          }),
        ],
        newTradeData.discount,
        newTradeData.SubTotal,
        newTradeData.Tax,
        newTradeData.totalAmountToPay,
        newTradeData.cashTenderedAmount,
        newTradeData.cashChangeOwed,
        newTradeData.giftCardPaymentHistory,
        false,
        isGiftReceipt,
        newTradeData.discountMethod,
        newTradeData.discountedValue,
        getReceiptPrintDate(newTradeData.createdOn),
        { isReprint: true }
      );
      printReceiptData(printData, defaultReceiptPrinter);
    }
  };
  const handlePrintReceiptTrade = (newTradeData, isGiftReceipt = false) => {
    const partialPayment =
      (newTradeData?.paymentHistory?.[transactionConstants.CASH] || 0) +
        (newTradeData?.paymentHistory?.[transactionConstants.STORE_CREDIT] ||
          0) >
        0 &&
      newTradeData?.totalAmountToPay !== newTradeData?.currentAmountToPay;
    const printData = prepareReceiptForPrinterTrade(
      getUserNameOnReceipt(newTradeData, user),
      newTradeData?.id,
      newTradeData?.paymentHistory,
      currentStore,
      allCustomers?.find((customer) => {
        if (customer.id === newTradeData?.customer?.id) {
          return {
            ...newTradeData?.customer,
            currentBalance: customer.currentBalance,
          };
        }
        return false;
      }) || {},
      [
        ...newTradeData?.inventory.map((inv) => {
          return {
            ...inv,
            cogs: inv?.price?.unit_purchase_price,
            item: inv?.product_name,
            priceAfterDiscount: partialPayment
              ? getUnitPurchasePrice(newTradeData, inv)
              : inv?.price?.unit_purchase_price,
            itemName: inv?.product_name,
            quantity: inv?.price?.quantity,
            productType: inv?.productType,
            category: inv?.category_name,
            actualPrice: partialPayment
              ? getUnitPurchasePrice(newTradeData, inv)
              : inv?.price?.unit_purchase_price,
            // max: 2,
            // actualPrice: inv?.price?.unit_sell_price,
            // isDiscountApplied: false,
            // discountPercentage: 0,
            // priceAfterDiscount: 1000,
            // actualDiscountPercentage: 0,
          };
        }),
      ],
      newTradeData?.discount,
      newTradeData?.SubTotal,
      newTradeData?.Tax,
      newTradeData?.totalAmountToPay,
      0,
      0,
      false,
      partialPayment,
      isGiftReceipt,
      getReceiptPrintDate(newTradeData.createdOn),
      { isReprint: true }
    );
    printReceiptData(printData, defaultReceiptPrinter);
  };
  const handleViewCart = async (row) => {
    setViewCartDetail([row]);

    if (isShopifyOrderHistory(row)) {
      const shopifyOrder = await shopifyService.getShopifyOrderById(
        currentStore?.id,
        row?.shopifyOrderId
      );
      setViewCartDetail([shopifyOrder]);
      toggleOrderDetailModal();
      return;
    }

    toggleCustomTradeModal();
  };
  const fetchMoreData = () => {
    updateGridState({
      ...gridState,
      pageSize:
        Number(
          gridState?.pageSize ?? inventoryConstants.ITEM_HISTORY_LIST_LENGTH
        ) + Number(inventoryConstants.ITEM_HISTORY_LIST_LENGTH),
    });
  };

  // useEffects
  useEffect(() => {
    if (
      selectedStoreId &&
      selectedStore?.value &&
      timeFrame.start &&
      timeFrame.end
    ) {
      /*
        If "All Stores" is selected in the dropdown, pass the comma-separated store ids explicitly.
        Otherwise, pass the selected store id from the dropdown.
        For dummy companies store with no company, always use the current store id.
      */
      getAllTransaction(
        selectedStoreId,
        option?.value,
        timeFrame.start,
        timeFrame.end,
        gridState,
        EMPTY_STRING
      );
    }

    return () => {
      emptyAllTransaction();
    };
    /* eslint-enable react-hooks/exhaustive-deps */
  }, [timeFrame.start, timeFrame.end, option, selectedStoreId]);
  /* eslint-enable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (viewCartDetail?.[0]?.id) {
      setViewCartDetail(
        sellTradeHistory?.filter((item) => item.id === viewCartDetail?.[0]?.id)
      );
    }
    // eslint-disable-next-line
  }, [sellTradeHistory]);

  return (
    <>
      <Row className="m-0">
        <Col md={12} className="d-flex align-items-center mb-2 gap-3">
          <div className={`w-100 d-flex align-items-center gap-3 `}>
            <DashboardDatePicker
              label="Date"
              getTimeFrame={handleGetTimeFrame}
              datePickerOptions={datePickerOptions}
            />
            <CompanyStoreDropdown
              currentStoreCompany={currentStoreCompany}
              companyStores={companyStores}
              selectedStore={selectedStore}
              setSelectedStore={setSelectedStore}
              className="dropdown-max-width"
            />
            <CategoriesDropdown
              label="Type"
              options={inventoryConstants.TRANSACTION_TYPE}
              handleChange={(e) => {
                setOption(
                  e == null
                    ? {
                        label: globalConstants.ALL,
                        value: globalConstants.ALL,
                      }
                    : e
                );
              }}
              noOptionsMessage="No Transaction Type Found"
              placeholder="Transaction Type"
              SelectIconImage={categoryDropdownConstants.TRANSACTION_ICON}
              className={"dropdown-max-width"}
              isClearable={false}
              defaultValue={{
                value: PRODUCT_TYPES_ENUMS.ALL,
                label: "All",
              }}
            />
            {isCustomerLogsModal.isSearchField && (
              <SearchField
                onChange={(e) => handleSearchInputChange(e.target.value)}
                IconImage={SearchIcon}
                BlueBoxIcon={BlueBoxIcon}
                label="Search"
                placeHolder="Type or Scan"
                value={debouncedSearchText}
                CrossIcon={debouncedSearchText ? CrossIcon : ""}
                clearSearchText={clearSearchText}
                LoadingIndicator={
                  isSearchLoading ||
                  (isButtonDisable(
                    spinnerArray,
                    transactionConstants.GET_ALL_TRANSACTION
                  ) &&
                    searchText)
                    ? LoadingIndicator
                    : false
                }
              />
            )}
          </div>
        </Col>
      </Row>
      <Row
        className={`m-0 w-100 h-100 user-screen-wrapper pt-3 p-0 ${
          isInfiniteScroll && isCustomerLogsModal.customer.id
            ? EMPTY_STRING
            : "pb-5 mb-2"
        }`}
      >
        {isInfiniteScroll ? (
          <InfiniteScrollTable
            columns={HistoryColumnsInfiniteScrollTable}
            data={gridData}
            update={fetchMoreData}
            tableId={tableId}
            hasMore={gridState?.pageSize < gridState?.totalRecords}
            isLoading={isSpinnerEnabled(
              spinnerArray,
              transactionConstants.GET_ALL_TRANSACTION
            )}
          />
        ) : (
          <ServerPaginationTable
            colDefs={HistoryColumnsPaginationTable}
            gridRef={gridRef}
            gridData={
              isSpinnerEnabled(
                spinnerArray,
                transactionConstants.GET_ALL_TRANSACTION
              )
                ? skeletonArray
                : gridData
            }
            gridState={gridState}
            getRowId={getRowId}
            singleClickEdit={false}
            getRowStyle={getRowStyle}
            updateGridState={updateGridState}
            paginationPageSize={gridState.pageSize}
            pageSizeOptions={gridState.pageSizeOptions}
            isDisablePaginationActions={isSpinnerEnabled(
              spinnerArray,
              transactionConstants.GET_ALL_TRANSACTION
            )}
            tableHeight={tableHeight}
            tableId={tableId}
          />
        )}
      </Row>
      <TransactionHistoryOrderDetailsModal
        show={show}
        handleHideModal={handleHideModal}
        hasAccessToVoidTransaction={hasAccessToVoidTransaction}
        viewCartDetail={viewCartDetail}
        allCustomers={allCustomers}
        handleUpdateCustomer={handleUpdateCustomer}
        handlePrintReceipt={handlePrintReceipt}
        sendEmailOrSMS={sendEmailOrSMS}
        handleInitiateVoid={handleInitiateVoid}
      />
      {/* as order detail has it's own addCustomerModal */}
      {isShowOrderDetail ? (
        <OrderDetailsModal
          orderDetail={viewCartDetail?.[0]}
          currentStore={currentStore}
          defaultGridState={gridState}
          shopifyOrdersCallBackConfig={{
            orderDetail: viewCartDetail?.[0],
            gridState: gridState,
            isRefetchTransactionsOnSave: true,
            callBackFuction: (updatedOrder) => {
              if (updatedOrder) setViewCartDetail([updatedOrder]);
            },
          }}
          isShowOrderDetail={isShowOrderDetail}
          handleMarkOrderAsOpen={handleMarkOrderAsOpen}
          toggleOrderDetailModal={toggleOrderDetailModal}
          handleMarkOrderAsReady={handleMarkOrderAsReady}
          updateShopifyOrderStatus={updateShopifyOrderStatus}
          handleMarkOrderAsFulfilled={handleMarkOrderAsFulfilled}
          handleTransferToLocation={handleTransferToLocation}
        />
      ) : null}
      <VoidTransactionModal
        show={showVoidModal}
        onHide={() => {
          setShowVoidModal(false);
          setTransactionToVoid(null);
        }}
        transaction={transactionToVoid}
        user={user}
        showDetails={showVoidDetails}
        onSubmitVoid={handleVoidTransaction}
      />
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  user: state.authentication.user,
  currentStore: state.store.currentStore,
  stores: state.store.stores,
  currentStoreCompany: state.company.currentStoreCompany,
  spinnerArray: state.system.spinnerArray,
  allCustomers: state.customer.allCustomers,
  allTransaction: state.transaction.allTransaction,
  paginationData: state.transaction.allTransaction.paginationData,
  sellTradeHistory: state.transaction.allTransaction.sellTradeHistory,
  defaultReceiptPrinter: state.printer.defaultReceiptPrinter,
  duplicateHistoryRecords: state.transaction.duplicateHistoryRecords,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getAllTransaction: (storeId, type, start, end, gridState, companyId) =>
    dispatch(
      transactionActions.getAllTransaction(
        storeId,
        type,
        start,
        end,
        gridState,
        companyId
      )
    ),
  emptyAllTransaction: () =>
    dispatch(success({}, transactionConstants.GET_ALL_TRANSACTION)),
  sendEmailOrSMS: (data) => dispatch(transactionActions.sendEmailOrSMS(data)),
  updateCustomerInTransactionHistory: (
    data,
    transactionDetails,
    gridState,
    endPoint
  ) =>
    dispatch(
      transactionActions.updateCustomerInTransactionHistory(
        data,
        transactionDetails,
        gridState,
        endPoint
      )
    ),
  getShopifyOrderById: (storeId, orderId) =>
    dispatch(shopifyActions.getShopifyOrderById(storeId, orderId)),
  updateShopifyOrderStatus: (
    storeId,
    data,
    gridState,
    toggleOrderDetailsModal
  ) =>
    dispatch(
      shopifyActions.updateShopifyOrderStatus(
        storeId,
        data,
        gridState,
        toggleOrderDetailsModal
      )
    ),
  updateVoidTransactionHistory: (
    data,
    transactionDetails,
    gridState,
    endpoint
  ) =>
    dispatch(
      transactionActions.updateVoidTransactionHistory(
        data,
        transactionDetails,
        gridState,
        endpoint
      )
    ),
});

//-------Export History Component
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TransactionHistoryTableWithFilters);
